import { DialogContent, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { Box } from '@mui/system';
import '@splidejs/react-splide/css';

import YouTube from 'react-youtube';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useCallback, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Vimeo from '@u-wave/react-vimeo';

type IProps = {
  toggle: boolean;
  onClose: () => void;
  contents: any[];
  index: number;
};

const opts = {
  height: '100%',
  width: '100%',
};

const FullscreenImageViewerDialog: React.FC<IProps> = ({
  toggle,
  onClose,
  contents,
  index,
}) => {
  return (
    <>
      <Dialog
        open={toggle}
        onClose={() => {
          onClose();
        }}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        maxWidth='lg'
        fullScreen
        sx={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 3000
        }}
      >
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{ position: 'absolute', right: 0, zIndex: 100000 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ padding: 0 }}>
          <>
            <Box>
              {contents != undefined && contents?.length > 0 && (
                <Splide
                  aria-label='Images'
                  options={{
                    perPage: 1,
                    // fixedHeight: 390,
                    height: '100vh',
                    // autoHeight: true,
                    start: index,
                  }}
                >
                  {contents?.map((content) => {
                    return content?.type === 'image' ? (
                      <SplideSlide key={content.id}>
                        <img
                          src={content?.link}
                          alt={content?.filename ?? ''}
                          height='100%'
                          width='100%'
                          className='object-fit-contain'
                        />
                      </SplideSlide>
                    ) : (
                      <SplideSlide key={content.id}>
                        {content?.platform === 'youtube' ? (
                          <YouTube
                            videoId={content?.link}
                            opts={opts}
                            className='object-fit-contain'
                            style={{
                              height: '100%',
                              width: '100%',
                            }}
                          // onPlay={() => handleOnplayVideo(content.id)}
                          />
                        ) : content?.platform === "vimeo" ? (
                          <Vimeo
                            video={content?.link}
                            className="object-fit-contain vimeo-video-contain"
                            height={"100%"}
                            width={"100%"}
                            style={{
                              height: "100%",
                              width: "100%",
                              maxHeight: '50vh'
                            }}
                          // onPlay={() => handleOnplayVideo(content.id)}
                          />
                        ) : (
                          <video
                            controls
                            width='100%'
                            height='100%'
                            className='object-fit-contain'
                            poster={content?.thumbnail ?? ''}
                          //onPlay={() => handleOnplayVideo(content.id)}
                          >
                            <source src={content?.link} type='video/mp4' />
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </SplideSlide>
                    );
                  })}
                </Splide>
              )}
            </Box>
          </>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FullscreenImageViewerDialog;
